import React, { useEffect, useState } from 'react';

const PageViews = () => {
  const [views, setViews] = useState([]);

  useEffect(() => {
    const fetchViews = async () => {
      const res = await fetch('https://ricgop.online/api/page-views.php');
      const data = await res.json();
      setViews(data);
    };

    fetchViews();
  }, []);

  return (
    <div className="max-w-4xl mx-auto py-10 px-4">
      <h2 className="text-3xl font-bold mb-6 text-indigo-700 text-center">Page View Statistics</h2>
      <div className="overflow-x-auto">
        <table className="w-full border border-gray-300 rounded-lg shadow">
          <thead className="bg-indigo-100">
            <tr>
              <th className="px-4 py-2 text-left">Page</th>
              <th className="px-4 py-2 text-left">Views</th>
              <th className="px-4 py-2 text-left">Last Viewed</th>
            </tr>
          </thead>
          <tbody>
            {views.map((view, i) => (
              <tr key={i} className="border-t hover:bg-gray-50">
                <td className="px-4 py-2">{view.page_path}</td>
                <td className="px-4 py-2">{view.view_count}</td>
                <td className="px-4 py-2">{new Date(view.last_viewed_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PageViews;
